/**
 * Created by RUSS_ on 07.05.2018
 *
 * Note: don't change id's of cookies because these are used as keys
 */

export default {
  generate: () => {
    const config = {
      necessary: {
        name: `${myTranslation("necessary")} Cookies`,
        description: myTranslation("necessary_desc"),
        list: [
          {
            id: "atzone_necessary",
            name: "AT-ZONE",
            description:
              "Get notifications whenever one of your contacts enter or leave defined zone!",
            usage: {
              en:
                "Get notifications whenever one of your contacts enter or leave defined zone!",
              de:
                "Sie wissen immer, wann Ihre Kontakte definierte Zonen betreten oder verlassen!",
              ru:
                "Получайте уведомления, когда ваши контакты входят или выходят из заданной зоны!"
            },
            domains: [
              "at-zone.com",
              "at-zone.de",
              "at-zone.ru",
              "v-zone.ru",
              "в-зоне.рф"
            ],
            privacy: "https://at-zone.com/privacy",
            terms: "https://at-zone.com/terms",
            accepted: true,
            immutable: true
          }
        ]
      },
      preferences: {
        name: `${myTranslation("preferences")} Cookies`,
        description: myTranslation("preferences_desc"),
        list: [
          {
            id: "firebase_login",
            name: "Firebase",
            description:
              "Firebase helps mobile and web app teams succeed!",
            usage: {
              en:
                "Firebase helps mobile and web app teams succeed!",
              de:
                "Firebase helps mobile and web app teams succeed!",
              ru:
                "Firebase helps mobile and web app teams succeed!"
            },
            domains: ["gstatic.com", "firebase.com"],
            privacy: "https://policies.google.com/privacy",
            terms: "https://firebase.google.com/terms/",
            accepted: false,
            immutable: false
          }
        ]
      },
      statistics: {
        name: `${myTranslation("statistics")} Cookies`,
        description: myTranslation("statistics_desc"),
        list: [
          {
            id: "google_analytics",
            name: "Google Analytics",
            description:
              "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Analytics cookies are used to collect some useful statistics about user experience on our web page.",
            usage: {
              en:
                "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Analytics cookies are used to collect some useful statistics about user experience on our web page.",
              de:
                "Google (www.google.com) betreibt das Google Display-Netzwerk eine Sammlung von Millionen von Websites und mobilen Anwendungen, die auf Display-Werbung basieren, darunter viele Google-Dienste wie YouTube. Analytics-Cookies werden verwendet, um einige nützliche Statistiken über die Nutzererfahrung auf unserer Webseite zu sammeln.",
              ru:
                "Google (www.google.com) управляет контекстно-медийной сетью Google, собрав миллионы веб-сайтов и мобильных приложений, которые работают на медийной рекламе, включая многие сервисы Google, такие как YouTube. Файлы cookie от Google Analytics используются для сбора полезной статистики о пользовательском опыте на нашей веб-странице."
            },
            domains: ["google.com", "google.de"],
            privacy: "http://www.google.com/intl/en/policies/privacy/",
            terms: "https://www.google.com/intl/en/policies/terms/",
            accepted: false,
            immutable: false
          }
        ]
      },
      marketing: {
        name: `${myTranslation("marketing")} Cookies`,
        description: myTranslation("marketing_desc"),
        list: [
          {
            id: "google_adsense",
            name: "Google Adsense.",
            description:
              "Google AdSense is a program run by Google that allows publishers in the Google Network of content sites to serve automatic text, image, video, or interactive media advertisements, that are targeted to site content and audience.",
            usage: {
              en:
                "Google AdSense is a program run by Google that allows publishers in the Google Network of content sites to serve automatic text, image, video, or interactive media advertisements, that are targeted to site content and audience.",
              de:
                "Google AdSense ist ein von Google betriebenes Programm, mit dem Publisher im Google-Werbenetzwerk von Content-Websites automatische Text-, Bild-, Video- oder interaktive Medienanzeigen schalten können, die auf Website-Content und Zielgruppe ausgerichtet sind.",
              ru:
                "Google AdSense - это программа от Google, которая позволяет издателям в сети контекстно-медийной сети Google обслуживать автоматические текстовые, графические, видео или интерактивные медиа-рекламы, предназначенные для контента и аудитории сайта."
            },
            domains: [
              "google.de",
              "google.com",
              "google.de",
              "googlesyndication.com",
              "googleads.g.doubleclick.net",
              "tpc.googlesyndication.com"
            ],
            privacy: "https://policies.google.com/privacy",
            terms: "https://www.google.com/adsense/new/localized-terms",
            accepted: false,
            immutable: false
          },
          {
            id: "youtube",
            name: "Youtube",
            description:
              "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Youtube cookies are used to get better experience on targeting ads to the user's interests based on the information that the cookie collected.",
            usage: {
              en:
                "Google (www.google.com) operates the Google Display Network a collection of millions of websites and mobile applications that are powered by display advertising, including many Google services like YouTube. Youtube cookies are used to get better experience on targeting ads to the user's interests based on the information that the cookie collected.",
              de:
                "Google (www.google.com) betreibt das Google Display-Netzwerk eine Sammlung von Millionen von Websites und mobilen Anwendungen, die auf Display-Werbung basieren, darunter viele Google-Dienste wie YouTube. Youtube-Cookies werden verwendet, um bessere Ergebnisse beim Targeting von Anzeigen auf die Interessen des Nutzers zu erzielen, basierend auf den Informationen, die der Cookie gesammelt hat.",
              ru:
                "Google (www.google.com) управляет контекстно-медийной сетью Google, собрав миллионы веб-сайтов и мобильных приложений, которые работают на медийной рекламе, включая многие сервисы Google, такие как YouTube. Cookie файды Youtube используются для получения лучшего опыта по таргетингу объявлений в интересах пользователя на основе информации, собранной cookie."
            },
            domains: ["www.youtube.com", "youtube.com"],
            privacy: "http://www.google.com/intl/en/policies/privacy/",
            terms: "https://www.google.com/intl/en/policies/terms/",
            accepted: false,
            immutable: false
          }
        ]
      }
    };
    return config;
  }
};



// WEBPACK FOOTER //
// ./src-cookie-manager/const/default-cookies-config.js